// extracted by mini-css-extract-plugin
export default {"mCard":"BB-z","image":"CB-z","imageNoBackground":"DB-z","imageHasCategory":"EB-z","fullWidth":"FB-z"};